import React from 'react';
import Header from '../../components/landing/Header';
import Footer from '../../components/landing/Footer';

const milestones = [
  {
    year: '2015',
    title: 'A different question',
    body:
      "PetCart begins with a question: what if pets had spaces and services designed for them, not retrofitted from people-first ones?",
  },
  {
    year: '2018',
    title: 'India\'s first pet resort',
    body:
      "PetCart Nest opens on the outskirts of Bangalore — boarding, swimming, hydrotherapy and socialization, all set in a green eco-system.",
  },
  {
    year: '2023',
    title: 'A wine cafe, for pet parents',
    body:
      "Wag & Wine launches — India's first wine cafe for pet parents and pet lovers. A space designed so people and their pets could unwind together.",
  },
  {
    year: 'Now',
    title: 'Category by category',
    body:
      "We're expanding into pet essentials, wellness and logistics — opening categories one at a time, each built to fit a real gap.",
  },
];

const OurStory = () => (
  <div className="min-h-screen bg-white overflow-x-hidden">
    <Header />

    <section className="border-b border-neutral-200 bg-neutral-50 pt-40 pb-12 sm:pt-48 sm:pb-16">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">Our story</p>
        <h1 className="mt-3 max-w-3xl text-4xl font-semibold leading-[1.1] tracking-tight text-neutral-900 sm:text-5xl lg:text-6xl">
          We didn't set out to start a pet company. We set out to fix one thing at a time.
        </h1>
      </div>
    </section>

    <section className="bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <ol className="relative space-y-12 sm:space-y-16">
          <span
            aria-hidden
            className="absolute left-[7px] top-2 bottom-2 hidden w-px bg-neutral-200 sm:block sm:left-[127px]"
          />
          {milestones.map((m, idx) => (
            <li key={m.year} className="relative flex flex-col gap-3 sm:flex-row sm:gap-10">
              <div className="flex items-baseline gap-3 sm:w-[120px] sm:justify-end sm:gap-0">
                <span className="text-2xl font-semibold tracking-tight text-neutral-900 sm:text-3xl">
                  {m.year}
                </span>
              </div>
              <span
                aria-hidden
                className="absolute left-0 top-3 hidden h-4 w-4 rounded-full border-2 border-primary bg-white sm:block sm:left-[120px]"
              />
              <div className="flex-1 sm:pl-2">
                <p className="text-[11px] font-semibold uppercase tracking-wider text-neutral-400">
                  Chapter {String(idx + 1).padStart(2, '0')}
                </p>
                <h3 className="mt-1 text-xl font-semibold text-neutral-900 sm:text-2xl">{m.title}</h3>
                <p className="mt-3 max-w-2xl text-[15px] leading-7 text-neutral-600">{m.body}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>

    <section className="bg-neutral-900 py-16 text-white sm:py-20">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">Still early</p>
        <p className="mt-4 text-xl font-medium leading-relaxed text-white/90 sm:text-2xl">
          We've opened two categories. There are many more to go — and we're in no rush to do them
          unless we can do them properly.
        </p>
      </div>
    </section>

    <Footer />
  </div>
);

export default OurStory;
